import React, { useState, useCallback, useEffect } from "react";
import { MasterTable } from "../../components/_index";
import {
  deleteCategory,
  getCategory,
  getRole,
} from "../../services/category.service";
import { Box, Stack, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";
// import AddCategory from "./AddCategory";
import {
  getMonthlyReport,
  getProjectDownloadTransaction,
  getProjectResponse,
  getProjectTransaction,
} from "../../services/transaction.service";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { DownloadExcel } from "./DownloadExcel";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { Autocomplete } from "@mui/material";
import DownloadButtonWithMenu from "../../components/DownloadButtonWithMenu/DownloadButtonWithMenu";

const MonthlyReport = () => {
  const { RangePicker } = DatePicker;
  const [data, setData] = useState([]);
  const [department, setDepartment] = useState([]);
  console.log("departmentdepartment", department);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [tableTotalCount, setTableCount] = useState(0);
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [categoryData, setCategoryData] = useState([]);

  const dispatch = useDispatch();
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
    status: "",
    startDate: dayjs().startOf("month").format("DD-MM-YYYY"),
    endDate: dayjs().endOf("month").format("DD-MM-YYYY"),
    department: "",
    category: "",

    // statusL//ist: [4, 2, 3],
  });

  const GetProjectTransactionData = async () => {
    try {
      const queryParams = { ...queryParam };

      if (Array.isArray(queryParams.statusList)) {
        queryParams.statusList = JSON.stringify(queryParams.statusList);
      }
      const res = await getMonthlyReport(queryParams);
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
          date: moment(e?.date).format("DD/MM/YYYY"),
        })) || [];
      setTableCount(res?.totalCount || 0);
      setData(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    // GetResponsiveFeedbackData();
    GetProjectTransactionData();
  }, [
    queryParam.search,
    queryParam.sort,
    queryParam.limit,
    queryParam.page,
    queryParam.startDate,
    queryParam.endDate,
    queryParam.department,
    queryParam.category
  ]);

  const columns = [
    { id: "date", label: "Date" },
    {id:"ticketId",label:"Ticket ID"},
    { id: "department", label: "Department" },
    { id: "category", label: "Category" },
    { id: "assignedTo", label: "Assigned To" },
    { id: "assignedDuration", label: "Assigned Duration" },
    { id: "completionDuration", label: "Completed Duration" },
    { id: "withinSLA", label: "Within SLA" },
    { id: "withoutSLA", label: "Without SLA" },
    { id: "status", label: "Status" },
    { id: "rating", label: "Showing Stars for Closed " },
  ];

  const GetCategoryDatas = async () => {
    try {
      const res = await getRole();
      // console.log(res, "CR");
      const modifiedData =
        res?.data
          .filter(
            (e) =>
              e.name === "HR" ||
              e.name === "PROJECT MANAGER" ||
              e.name === "FEEDBACK-ADMIN" ||
              e.name === "IT SUPPORT"
          )
          .map((e) => ({
            ...e,
            label: e.name,
            id: e._id,
          })) || [];
      setDepartment(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const excel_columns = columns.map((n) => ({
    header: n?.label,
    key: n?.id,
  }));

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  React.useEffect(() => {
    if (selectedRoleId) {
      getCategory({ departmentRoleId: selectedRoleId }).then((res) => {
        const modifiedData = res.data.map((el) => ({
          ...el,
          label: el?.name,
        }));
        setCategoryData(modifiedData);
      });
    }
  }, [selectedRoleId]);

  useEffect(() => {
    GetCategoryDatas();
  }, []);

  return (
    <div className="mainContent">
      <Grid container mb={2} spacing={1}>
        <Grid size={{ xs: 12, sm: 2 }}>
          <Box className="SearchInputBoxContainer">
            <SearchOutlinedIcon className="Search_Icon" />
            <input
              className="SearchInputBox"
              placeholder="Search here"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 2, md: 2.5 }}>
          <Autocomplete
            sx={{ width: 200 }}
            options={department}
            value={
              department.find((dept) => dept.id === selectedRoleId) || null
            }
            getOptionLabel={(option) => option.label}
            onChange={(e, v) => {
              const id = v?._id || "";
              setSelectedRoleId(id);
              setQueryParam((prev) => ({
                ...prev,
                department: id,
              }));
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select department" />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 2, md: 2.5 }}>
          <Autocomplete
            sx={{ width: 200 }}
            options={categoryData}
            value={
              categoryData.find((dept) => dept._id === selectedCategoryId) ||
              null
            }
            getOptionLabel={(option) => option.label}
            onChange={(e, v) => {
              const id = v?._id || "";
              setSelectedCategoryId(id);
              setQueryParam((prev) => ({
                ...prev,
                category: id,
              }));
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select category" />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4, md: 3 }}>
          <Grid>
            <RangePicker
              value={[
                queryParam.startDate
                  ? dayjs(queryParam.startDate, "DD-MM-YYYY")
                  : null,
                queryParam.endDate
                  ? dayjs(queryParam.endDate, "DD-MM-YYYY")
                  : null,
                ,
              ]}
              onChange={(e) => {
                setQueryParam({
                  ...queryParam,
                  startDate: e?.[0] ? dayjs(e?.[0]).format("DD-MM-YYYY") : null,
                  endDate: e?.[1] ? dayjs(e?.[1]).format("DD-MM-YYYY") : null,
                });
              }}
              style={{
                height: "38px",
              }}
            />
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 2 }}>
          <Stack>
            <DownloadButtonWithMenu
              excelData={data}
              excelColumns={excel_columns}
              filename={"Monthly Report"}
            />
          </Stack>
        </Grid>
      </Grid>
      <MasterTable
        data={data}
        columns={columns}
        isServerSide={false}
        // handleView={handleView}
        // handleEdit={handleEdit}
        // handleDelete={handleDelete}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />
    </div>
  );
};

export default MonthlyReport;
